import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import plpGrid from './plp-grid';

export default () => {
	const items = document.querySelectorAll('.js-filter-group .js-filter-item');
	const sortItems = document.querySelectorAll('.filter-block--sort .filter-block__btn');

	items.forEach(function(item) {
		item.addEventListener('click', (e) => {
			setTimeout(function(){
				applyFilter();
			}, 10);
		});
	});

	sortItems.forEach(function(item) {
		item.addEventListener('click', (e) => {
			if (!item.classList.contains('js-sortby-default')) {
				disableDisruptiveGrid();
			} else {

			}

			setTimeout(function(){
				applyFilter();
			}, 10);
		});
	});
}

function scrollToTop() {
	const block = document.querySelector('.collection__products, #shopify-section-search-main .js-collection-grid');
	if (!block) return;
	const header = document.querySelector('.header');
	const filter = document.querySelector('.js-filter');
	let blockOffset = block.offsetTop;
	let scrollPos = window.scrollY;
	let headerHeight = header.offsetHeight;
	let filterHeight = filter.offsetHeight;
	let targetPos = blockOffset - headerHeight - filterHeight;

	if (scrollPos > targetPos) {
		let offset = {};
		offset.val = scrollPos;

		gsap.to(offset, {
			val: targetPos,
			duration: 1,
			ease: 'power3.out',
			onUpdate: () => {
				window.scrollTo(0, offset.val);
			}
		});
	} else {

	}
}

function applyFilter() {
	scrollToTop();
	const filter = document.querySelector('.js-filter');
	let grid = document.querySelector('.js-collection-grid');
	let activeItems = document.querySelectorAll('.js-filter-group .filter-block__btn--active');
	let sectionId;
	let filtersString = '';
	const section = filter.closest('.shopify-section');

	if (section) {
		sectionId = ''+section.id.replace('shopify-section-', '');
	}

	gsap.to(grid, {
		filter: 'blur(32px)',
		opacity: 0,
		duration: 0.3
	});

	activeItems.forEach(function(active) {
		let item = active.closest('.js-filter-item');
		if (item) {
			let name = item.dataset.param;
			let value = item.dataset.value;

			if (name && value) {
				filtersString += `&${name}=${value}`;
			}
		}
	});

	if	(filtersString != '') {
		disableDisruptiveGrid();
	}


	const activeSortBtn = document.querySelector('.filter-block--sort .filter-block__btn--active');
	if (activeSortBtn) {
		filtersString += `&sort_by=${activeSortBtn.dataset.id}`;
	}

	const base = window.location.href.split('?')[0];
	let search = window.location.search;
	search = search.replace('?', '&');
	let url = `${base}?section_id=${sectionId}${search}${filtersString}`;

	fetch(url).then(function (response) {
		return response.text();
	}).then(function (html) {
		let element = document.createElement('div');
		element.innerHTML = html
		let newGrid = element.querySelector('.js-collection-grid');
		const counter = document.querySelector('.js-collection-count');
		grid.innerHTML = newGrid.innerHTML;

		let cards = grid.querySelectorAll('.card');

		cards.forEach(function(card) {
			window.initCard(card);
		});
		plpGrid();

		gsap.to(grid, {
			opacity: 1,
			filter: 'blur(0px)',
			duration: 0.3,
			delay: 0.3
		});

		ScrollTrigger.refresh();

		if (counter) {
			counter.innerText = cards.length;
		}

	}).catch(function (err) {
		console.warn('Something went wrong.', err);
	});
}

function disableDisruptiveGrid() {
	const gridBtns = document.querySelectorAll('.filter__grid-button');
	const activeGridBtn = document.querySelector('.filter__grid-button--active');
	if (activeGridBtn.classList.contains('js-sortby-default')) {

	} else {
		// gridBtns[0].click();
	}
}
function clearFilter() {
	console.log('clearFilter()');
	const deleteFiltersButton = document.querySelector('.js-clear-btn');
	const activeItems = document.querySelectorAll('.js-filter-group .filter-block__btn--active');
	activeItems.forEach(function(btn) {
		btn.classList.remove('filter-block__btn--active');
	});

	const filterCounters = document.querySelectorAll('.js-filter-count');
	filterCounters.forEach(filterCounter => {
		filterCounter.innerText = '';
	});

	applyFilter();
	const activeFilterButtons = document.querySelectorAll('.filter__tabs .filter-block__btn--active');
	if (deleteFiltersButton) {
		deleteFiltersButton.classList.remove('filter__clear-btn--visible');
	}
}


export { applyFilter, clearFilter };
